import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { CLAIMS_ACTIONS } from '../actions/claims.actions';

export const CLAIMS_STATE_KEY = 'claims';

export interface IClaimsState {
  loading: boolean;
  error: boolean;
  claims: string[];
}

export const initialState: IClaimsState = {
  loading: true,
  error: false,
  claims: [],
};

const _claimsReducer: ActionReducer<IClaimsState> = createReducer<IClaimsState>(
  initialState,
  on(CLAIMS_ACTIONS.getClaims, (state) => ({ ...state, loading: true, error: false })),
  on(CLAIMS_ACTIONS.getClaimsSuccess, (state, { payload }) => ({ ...state, loading: false, claims: payload })),
  on(CLAIMS_ACTIONS.getClaimsError, (state) => ({ ...state, loading: false, error: true })),
);

export const claimsReducer = (state: IClaimsState | undefined, action: Action): IClaimsState =>
  _claimsReducer(state, action);
